import { useRef, useState, useEffect } from "react";
import { AnimatePresence, motion, useScroll } from "framer-motion";
import { Sticker, SIGNAL, SIGNAL_TEXT, SIGNAL_WORD } from "./Sticker";

const STATES = [
  { key: "green", word: SIGNAL_WORD.green, meaning: "Fresh" },
  { key: "yellow", word: SIGNAL_WORD.yellow, meaning: "Use today" },
  { key: "red", word: SIGNAL_WORD.red, meaning: "Discard" },
];

export const SignalStates = () => {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start start", "end end"] });
  const [idx, setIdx] = useState(0);

  useEffect(() => scrollYProgress.on("change", (v) => setIdx(Math.min(2, Math.floor(v * 3)))), [scrollYProgress]);

  const s = STATES[idx];

  return (
    <section ref={ref} data-testid="signal-states-section" className="relative on-dark bg-[#0D1B2A] text-[#F2F3F5] h-[220vh] md:h-[320vh]">
      <div className="sticky top-0 h-[100svh] overflow-hidden">
        <div className="absolute left-6 top-24 md:left-10 md:top-28">
          <p className="eyebrow text-[#F2F3F5]/70">Freshness indicator / 001</p>
        </div>

        <div className="absolute left-6 md:left-10 bottom-[10vh] md:bottom-auto md:top-1/2 md:-translate-y-1/2 z-10">
          <AnimatePresence mode="wait">
            <motion.div
              key={s.key}
              data-testid={`state-word-${s.key}`}
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              exit={{ opacity: 0, y: -20 }}
              transition={{ duration: 0.55, ease: [0.22, 1, 0.36, 1] }}
            >
              <div className="flex items-baseline gap-4 md:gap-6">
                <span className="mono text-sm md:text-base" style={{ color: SIGNAL_TEXT[s.key] }}>
                  0{idx + 1}
                </span>
                <h2 className="display text-[3.2rem] sm:text-7xl lg:text-[7.5rem]" style={{ color: SIGNAL_TEXT[s.key] }}>
                  {s.word}
                </h2>
              </div>
              <p className="display text-[1.6rem] sm:text-4xl lg:text-5xl mt-3 text-[#F2F3F5]">{s.meaning}</p>
            </motion.div>
          </AnimatePresence>
        </div>

        <div className="absolute right-[-12vw] top-[12vh] w-[70vw] md:right-[6vw] md:top-1/2 md:-translate-y-1/2 md:w-[min(46vw,620px)]">
          <Sticker state={s.key} testId="states-sticker" />
        </div>

        <div className="absolute left-6 right-6 md:left-10 md:right-auto md:w-[36vw] bottom-[5vh] flex gap-1" data-testid="state-progress">
          {STATES.map((st, i) => (
            <span
              key={st.key}
              className="h-px flex-1 transition-colors duration-700"
              style={{ background: i <= idx ? SIGNAL[st.key] : "rgba(242,243,245,0.18)" }}
            />
          ))}
        </div>
      </div>
    </section>
  );
};
